import Controller from '@ember/controller';
import { service } from '@ember/service';

import { GEOS } from 'core/utils/constants';

export default class TerraformController extends Controller {
  @service config;

  get deployGeo() {
    return this.config.app?.deployGeo ?? GEOS.US;
  }
}
